import { useNetworkSettings as useNetworkSettingsContext } from 'contexts/NetworkSettingsContext';

export const useNetworkSettings = () => {
  const {
    networkSettings,
    loading,
    error,
    fetchNetworkSettings,
    updateNetworkSettings,
  } = useNetworkSettingsContext();

  // Utility functions for common use cases
  const shouldShowLogo = () => !networkSettings.hide_logo;
  const shouldShowLogout = () => !networkSettings.hide_logout;
  const getNavbarColor = (isDarkMode = false) => {
    return isDarkMode
      ? networkSettings.navbar_color_dark_mode || '#000000'
      : networkSettings.navbar_color_light_mode || '#444444';
  };
  const getDirectorySettings = () => ({
    displayDevice: networkSettings.directoryDisplayDevice || 'TOUCH_SCREEN',
    itemsPerSlide: networkSettings.directoryItemsPerSlide || 5,
    autoplaySpeed: networkSettings.directoryAutoplaySpeed || 3000,
  });

  // Add utility function for navbar mode
  const getNavbarMode = () => networkSettings.navbar_current_mode || 'dark';
  const isDarkMode = () => networkSettings.navbar_current_mode === 'dark';

  return {
    // Original context values
    networkSettings,
    loading,
    error,
    fetchNetworkSettings,
    updateNetworkSettings,

    // Utility functions
    shouldShowLogo,
    shouldShowLogout,
    getNavbarColor,
    getDirectorySettings,
    getNavbarMode,
    isDarkMode,
  };
};
